<template>
  <b-modal
    no-close-on-backdrop
    centered
    ok-only
    size="lg"
    ok-title="Fechar"
    ok-variant="danger"
    v-model="open"
    title="Atualizar colaborador"
    :busy="loading"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>

    <b-row v-else class="container">
      <b-col cols="9" class="mb-2">
        <label>Nome do colaborador</label>
        <input
          type="text"
          class="form-control"
          v-model="name"
          placeholder="Digite o nome do colaborador"
        />
      </b-col>

      <b-col cols="3" class="mb-2">
        <label>ID Externo</label>
        <input
          type="text"
          class="form-control"
          v-model="id_external"
          placeholder="Id externo"
        />
      </b-col>

      <b-col cols="12" class="mb-2">
        <label>Email</label>
        <input
          type="email"
          class="form-control"
          v-model="email"
          placeholder="Digite o email do colaborador"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>CPF</label>
        <input
          type="text"
          v-mask="['###.###.###-##']"
          class="form-control"
          v-model="cpf"
          placeholder="Digite o cpf"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>WhatsApp</label>
        <input
          type="text"
          v-mask="['(##) #####-####', '(##) ####-####']"
          class="form-control"
          v-model="phone"
          placeholder="Digite o número do whatsapp"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>Cupom</label>
        <input
          type="text"
          maxlength="8"
          class="form-control"
          v-model="code"
          @keyup="uppercaseText()"
          placeholder="Crie seu cupom"
        />
      </b-col>

      <b-col cols="6" class="mb-2">
        <label>Status</label>
        <v-select
          id="status"
          label="Status"
          v-model="status"
          :options="['Ativo', 'Bloqueado']"
        >
          <div slot="no-options">Não encontrou nada.</div>
        </v-select>
      </b-col>

      <b-col cols="12" class="text-center pl-4 pr-4 mt-3">
        <b-button variant="success" @click="update()"> Atualizar </b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';
import { mapState, mapActions } from 'vuex';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'ModalNewClerk',
  mixins: [makeToast],
  $emits: ['clerkUpdate'],

  data() {
    return {
      loading: false,
      open: false,
      code: '',
      name: '',
      cpf: '',
      phone: '',
      status: '',
      idUser: '',
      email: '',
      id_external: '',
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {
    toggleOpen({ id, name, phone, code, cpf, status, email, id_external }) {
      this.open = !this.open;
      this.idUser = id;
      this.name = name;
      this.phone = phone;
      this.code = code;
      this.cpf = cpf;
      this.status = status == 1 ? 'Ativo' : 'Bloqueado';
      this.email = email;
      this.id_external = id_external;
    },

    uppercaseText() {
      this.code = this.code.toUpperCase();
    },

    unsMaskValor(value) {
      return parseInt(String(value).replace(/[\D]+/g, ''));
    },
    update() {
      if (this.name == '') {
        this.makeToast('Erro', 'Nome não pode estar vazio!', 'danger');
        return;
      }
      if (this.cpf == '') {
        this.makeToast('Erro', 'CPF não pode estar vazio!', 'danger');
        return;
      }
      if (this.phone == '') {
        this.makeToast('Erro', 'Telefone não pode estar vazio!', 'danger');
        return;
      }
      //  if(this.code == ''){
      //   this.makeToast(
      //       'Erro',
      //       'Cupom não pode estar vazio!',
      //       'danger'
      //   );
      //   return
      //  }
      //  if(this.code.length < 8){
      //   this.makeToast(
      //       'Erro',
      //       'Cupom tem que ter no minimo 6 digitos',
      //       'danger'
      //   );
      //   return
      //  }

      const data = {
        id: this.idUser, //ID DA TABELA
        name: this.name,
        cpf: this.unsMaskValor(this.cpf),
        phone: this.unsMaskValor(this.phone),
        code: this.code,
        construp_user_id: this.userTypeId(),
        status: this.status == 'Ativo' ? 1 : 0,
        email: this.email,
        id_external: this.id_external,
      };

      this.loading = true;

      this.$store
        .dispatch('shopkeeper/updateClerk', data)
        .then((response) => {
          this.makeToast(
            'Sucesso',
            'Dados atualizados com sucesso!',
            'success'
          );
          this.$emit('clerkUpdate');
          this.open = !this.open;
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao salvar os dados, tente novamente',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
  },
};
</script>
